import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCantileverSymbol = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 195,
	height: 67,
	viewBox: "0 0 195 67",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 67V33.5V0C6.5942 5.77153 35.0435 30.15 96.087 30.15C157.13 30.15 187.464 5.77153 195 0V67C187.464 61.2285 157.13 36.85 96.087 36.85C35.0435 36.85 6.5942 61.2285 0 67Z",
		fill: "black"
	})
});
export default SvgCantileverSymbol;
